/* Keep availability filtering upstream of Shopify's pagination. */
(function () {
  'use strict';
  var titleTerms = window.MonacoTitleSearch.terms;
  var productMatches = window.MonacoTitleSearch.productMatches;
  var identifierMatches = window.MonacoTitleSearch.identifierMatches;
  var catalog = window.MonacoTitleSearch.catalog;
  var titleQuery = window.MonacoTitleSearch.query;

  function reconcileTitleFilters(form, products) {
    form.querySelectorAll('.clp-filter-option').forEach(function (label) {
      var input = label.querySelector('input');
      if (!input) return;
      var count = products.filter(function (product) {
        var values = product.facets && product.facets[input.name];
        return Array.isArray(values) && values.flat(Infinity).includes(input.value);
      }).length;
      label.hidden = !count && !input.checked;
      input.disabled = !count && !input.checked;
      var badge = label.querySelector('.clp-filter-count');
      if (badge) badge.textContent = String(count);
    });
    form.querySelectorAll('.clp-filter-group').forEach(function (group) {
      var options = Array.from(group.querySelectorAll('.clp-filter-option'));
      group.hidden = options.length > 0 && options.every(function (option) { return option.hidden; });
    });
    var priceMax = form.querySelector('[name="filter.v.price.lte"]');
    if (priceMax) priceMax.placeholder = String(products.reduce(function (max, product) { return Math.max(max, Number(product.priceMax) || 0); }, 0) / 100);
  }

  function setWatchStatus(root, text) {
    var status = root.querySelector('#search-status');
    if (!status) return;
    status.dataset.watchBase = text;
    var count = Number(status.dataset.exactSkuCount || 0);
    status.textContent = text + (count ? ' · ' + count + ' sold exact SKU match' + (count === 1 ? '' : 'es') : '');
  }

  async function mountWatchResults(root, location) {
    var query = location.searchParams.get('q') || '';
    if (!root || !query.trim() || query.trim() === '*') return;
    var terms = titleTerms(query);
    var prefix = location.searchParams.get('title_prefix') === '1';
    var identifierSearch = false;
    var hadVerifiedResults = root.dataset.titleVerified === 'true';
    var labelsNode = root.querySelector('[data-watch-search-labels]');
    if (!labelsNode) throw new Error('Missing watch search labels');
    var labels = JSON.parse(labelsNode.textContent);
    var grid = root.querySelector('[data-collection-grid]');
    var status = root.querySelector('#search-status');
    var oldRetry = root.querySelector('[data-watch-search-retry]');
    if (oldRetry) oldRetry.remove();
    if (!hadVerifiedResults) document.querySelectorAll('#preview-filter-form .clp-filter-group').forEach(function (group) { group.hidden = true; });
    root.dataset.watchSearchState = hadVerifiedResults ? 'refreshing' : 'loading';
    document.documentElement.classList.add('preview-watch-search');
    grid.setAttribute('aria-busy', 'true');
    setWatchStatus(root, labels.loading);
    try {
      var source = new URL(root.dataset.searchUrl || location.pathname, location);
      var catalogController = new AbortController();
      var catalogTimeout = setTimeout(function () { catalogController.abort(); }, 30000);
      try {
        var candidates = await catalog(source.href, catalogController.signal);
        identifierSearch = candidates.some(function (product) { return identifierMatches(product, query); });
      } finally { clearTimeout(catalogTimeout); }
      source.search = location.search;
      source.searchParams.delete('section_id');
      source.searchParams.set('view', 'preview-watch');
      source.searchParams.set('q', identifierSearch ? '*' : titleQuery(terms, prefix));
      source.searchParams.set('type', 'product');
      source.searchParams.set('options[unavailable_products]', identifierSearch ? 'show' : 'hide');
      source.searchParams.delete('title_include_sold');
      async function readPage(page) {
        var request = new URL(source);
        request.searchParams.set('page', String(page));
        var controller = new AbortController();
        var timeout = setTimeout(function () { controller.abort(); }, 30000);
        try {
          var response = await fetch(request.href, { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: controller.signal });
          if (!response.ok) throw new Error('Watch search request failed');
          var data = JSON.parse(await response.text());
          if (!data || data.page !== page || !Number.isInteger(data.pages) || data.pages < 0 ||
              !Number.isInteger(data.total) || data.total < 0 || data.total > 25000 ||
              !Number.isInteger(data.scanned) || data.scanned < 0 || data.scanned > 250 ||
              !Array.isArray(data.products) || data.products.length > data.scanned ||
              data.pages !== Math.max(1, Math.ceil(data.total / 250)) ||
              data.products.some(function (product) { return !Number.isSafeInteger(product.id) || typeof product.html !== 'string' || typeof product.title !== 'string' || typeof product.available !== 'boolean' || !Array.isArray(product.skus) || !Array.isArray(product.serials); })) {
            throw new Error('Incomplete watch search response');
          }
          return data;
        } finally { clearTimeout(timeout); }
      }
      var first = terms.length ? await readPage(1) : { page: 1, pages: 1, total: 0, scanned: 0, products: [] };
      var pages = [first];
      var next = 2;
      async function worker() {
        while (next <= first.pages) {
          var number = next++;
          var data = await readPage(number);
          if (data.total !== first.total || data.pages !== first.pages) throw new Error('Watch search changed while loading');
          pages[number - 1] = data;
        }
      }
      await Promise.all(Array.from({ length: Math.min(3, Math.max(0, first.pages - 1)) }, worker));
      if (pages.reduce(function (sum, page) { return sum + page.scanned; }, 0) !== first.total) throw new Error('Watch search was truncated');
      var products = pages.flatMap(function (page) { return page.products; });
      if (new Set(products.map(function (product) { return product.id; })).size !== products.length) throw new Error('Watch search changed while loading');
      products = products.filter(function (product) { return identifierSearch ? identifierMatches(product, query) : productMatches(product, query, prefix); });
      if (terms.length) {
        var facetSource = new URL(source);
        facetSource.searchParams.delete('view');
        facetSource.searchParams.set('section_id', 'preview-search');
        facetSource.searchParams.set('page', '1');
        var facetController = new AbortController();
        var facetTimeout = setTimeout(function () { facetController.abort(); }, 30000);
        try {
          var facetResponse = await fetch(facetSource.href, { credentials: 'same-origin', signal: facetController.signal });
          if (!facetResponse.ok) throw new Error('Title search filters could not be loaded');
          var facetDocument = new DOMParser().parseFromString(await facetResponse.text(), 'text/html');
          var facetForm = facetDocument.querySelector('#preview-filter-form');
          var currentForm = document.querySelector('#preview-filter-form');
          var actions = currentForm && currentForm.querySelector('.clp-filter-actions');
          if (!facetForm || !actions) throw new Error('Incomplete title search filters');
          currentForm.querySelectorAll('.clp-filter-group').forEach(function (group) { group.remove(); });
          facetForm.querySelectorAll('.clp-filter-group').forEach(function (group) { actions.before(group); });
          reconcileTitleFilters(currentForm, products);
          currentForm.querySelectorAll('[name="title_include_sold"]').forEach(function (input) { input.remove(); });
          var availabilityInput = currentForm.querySelector('[name="options[unavailable_products]"]');
          if (availabilityInput) availabilityInput.value = 'hide';
          root.querySelectorAll('.clp-clear').forEach(function (link) {
            var target = new URL(link.href);
            target.searchParams.delete('title_include_sold');
            target.searchParams.set('options[unavailable_products]', 'hide');
            link.href = target.href;
          });
          if (prefix && !currentForm.querySelector('[name="title_prefix"]')) {
            var prefixInput = document.createElement('input');
            prefixInput.type = 'hidden'; prefixInput.name = 'title_prefix'; prefixInput.value = '1';
            currentForm.append(prefixInput);
            root.querySelectorAll('.clp-clear').forEach(function (link) { var target = new URL(link.href); target.searchParams.set('title_prefix', '1'); link.href = target.href; });
          }
        } finally { clearTimeout(facetTimeout); }
      }
      var pageCount = Math.max(1, Math.ceil(products.length / 24));
      var page = Math.min(pageCount, Math.max(1, Number.parseInt(location.searchParams.get('page'), 10) || 1));
      var offset = (page - 1) * 24;
      grid.innerHTML = products.slice(offset, offset + 24).map(function (product) { return product.html; }).join('');
      setWatchStatus(root, products.length ? labels.showing.replace('[start]', String(offset + 1)).replace('[end]', String(Math.min(offset + 24, products.length))).replace('[total]', String(products.length)) : labels.none);
      var empty = root.querySelector('.sr-empty');
      if (empty) empty.hidden = products.length > 0 || Number(status.dataset.exactSkuCount || 0) > 0;
      var oldPager = root.querySelector('.clp-pagination');
      if (oldPager) oldPager.remove();
      var clean = new URL(location);
      clean.searchParams.delete('section_id');
      clean.searchParams.delete('view');
      if (page !== (Number.parseInt(location.searchParams.get('page'), 10) || 1)) {
        clean.searchParams.set('page', String(page));
        window.history.replaceState(null, '', clean.href);
      }
      if (pageCount > 1) {
        var pager = document.createElement('nav');
        pager.className = 'clp-pagination preview-pagination';
        pager.setAttribute('aria-label', labels.pagination);
        function link(number, text, label) {
          var anchor = document.createElement('a');
          var target = new URL(clean);
          target.searchParams.set('page', String(number));
          anchor.href = target.href;
          anchor.textContent = text;
          if (label) anchor.setAttribute('aria-label', label);
          pager.append(anchor);
        }
        if (page > 1) link(page - 1, '‹', labels.previous);
        var start = Math.max(1, Math.min(page - 1, pageCount - 3));
        var end = Math.min(pageCount, start + 3);
        for (var number = start; number <= end; number++) {
          if (number === page) {
            var current = document.createElement('span');
            current.setAttribute('aria-current', 'page');
            current.textContent = String(number);
            pager.append(current);
          } else link(number, String(number));
        }
        if (page < pageCount) link(page + 1, '›', labels.next);
        grid.after(pager);
      }
      root.dataset.watchSearchState = 'ready';
      root.dataset.titleVerified = 'true';
    } catch (error) {
      root.dataset.watchSearchState = hadVerifiedResults ? 'ready' : 'error';
      setWatchStatus(root, labels.error);
      var retry = document.createElement('button');
      retry.type = 'button';
      retry.className = 'clp-action';
      retry.dataset.watchSearchRetry = '';
      retry.textContent = labels.retry;
      retry.addEventListener('click', function () { mountWatchResults(root, location); });
      status.after(retry);
      console.warn('Watch search could not be completed.', error);
    } finally {
      grid.removeAttribute('aria-busy');
    }
  }

  var url = new URL(window.location.href);
  var isCollection = /\/collections\/[^/]+(?:\/[^/]+)?\/?$/.test(url.pathname);
  var isSearch = /\/search\/?$/.test(url.pathname);
  if (!isCollection && !isSearch) {
    // The search section can also be placed on a 404 or content page. Liquid's
    // collections.all fallback is not availability-filtered on those routes.
    // Ask Shopify to filter AND paginate first, rather than dropping sold cards
    // after pagination (which leaves short pages and inflated result totals).
    var embedded = document.querySelector('[data-native-search]');
    if (!embedded) return;
    var source = new URL('/search', url.origin);
    source.search = url.search;
    source.searchParams.set('q', (source.searchParams.get('q') || '').trim() || '*');
    source.searchParams.set('type', 'product');
    source.searchParams.set('options[unavailable_products]', 'hide');
    source.searchParams.delete('title_include_sold');
    source.searchParams.set('section_id', 'preview-search');
    document.documentElement.classList.add('preview-catalog-normalizing');
    fetch(source.href, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Collection search refresh failed');
        return response.text();
      })
      .then(function (html) {
        var result = new DOMParser().parseFromString(html, 'text/html');
        var fresh = result.querySelector('[data-native-search]');
        var freshGrid = fresh && fresh.querySelector('[data-collection-grid]');
        var freshStatus = fresh && fresh.querySelector('#search-status');
        if (!freshGrid || !freshStatus) throw new Error('Incomplete collection search refresh');
        // Keep the existing grid, controls and form nodes so their listeners stay attached.
        embedded.querySelector('[data-collection-grid]').innerHTML = freshGrid.innerHTML;
        embedded.querySelector('#search-status').textContent = freshStatus.textContent;
        var filters = embedded.querySelector('#preview-filter-form');
        var freshFilters = fresh.querySelector('#preview-filter-form');
        if (filters && freshFilters) filters.innerHTML = freshFilters.innerHTML;
        var sort = embedded.querySelector('[data-native-sort]');
        var freshSort = fresh.querySelector('[data-native-sort]');
        if (sort && freshSort) sort.innerHTML = freshSort.innerHTML;
        var oldPager = embedded.querySelector('.clp-pagination');
        var freshPager = fresh.querySelector('.clp-pagination');
        if (freshPager) {
          freshPager.querySelectorAll('a[href]').forEach(function (link) {
            var next = new URL(link.getAttribute('href'), source);
            next.pathname = url.pathname;
            next.searchParams.delete('section_id');
            link.href = next.href;
          });
          if (oldPager) oldPager.replaceWith(freshPager);
          else embedded.querySelector('.clp-catalog').append(freshPager);
        } else if (oldPager) oldPager.remove();
        var oldEmpty = embedded.querySelector('.sr-empty');
        if (oldEmpty) oldEmpty.remove();
        var freshEmpty = fresh.querySelector('.sr-empty');
        if (freshEmpty) embedded.querySelector('[data-collection-grid]').after(freshEmpty);
        return mountWatchResults(embedded, url);
      })
      .catch(function (error) {
        console.warn('Embedded collection search could not be refreshed.', error);
      })
      .finally(function () {
        document.documentElement.classList.remove('preview-catalog-normalizing');
      });
    return;
  }
  var originalQuery = (url.searchParams.get('q') || '').trim();
  var before = url.search;
  if (isCollection) {
    url.searchParams.delete('filter.v.availability');
    url.searchParams.set('filter.v.availability', '1');
  } else {
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[unavailable_products]', 'hide');
    url.searchParams.delete('title_include_sold');
    if (!originalQuery) url.searchParams.set('q', '*');
  }
  // Compare parameter values, not URL encoding or parameter order.
  var current = new URLSearchParams(before);
  var changed = Array.from(url.searchParams).some(function (pair) {
    return current.getAll(pair[0]).join('\n') !== url.searchParams.getAll(pair[0]).join('\n');
  }) || Array.from(current.keys()).some(function (key) { return !url.searchParams.has(key); });
  if (changed) {
    document.documentElement.classList.add('preview-catalog-normalizing');
    window.location.replace(url.href);
    return;
  }
  if (!isSearch || !originalQuery || originalQuery === '*') return;
  document.addEventListener('DOMContentLoaded', function () { mountWatchResults(document.querySelector('[data-native-search]'), url); });
}());


